module.exports = __webpack_public_path__ + "img/石化行业数字化转型场景图谱.9f3bcd23.jpg";